import { clsx } from "clsx";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function catchFunction(error) {}

export const getCurrentMonthRange = () => {
  const today = new Date();
  return {
    from: new Date(today.getFullYear(), today.getMonth(), 1),
    to: today,
  };
};

export const dateRangeTransformer = (dateRange) => {
  return {
    from: dateTransformer(dateRange.from),
    to: dateTransformer(dateRange.to),
  };
};

export const dateTransformer = (date) => {
  let d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) {
    month = "0" + month;
  }

  if (day.length < 2) {
    day = "0" + day;
  }

  return [year, month, day].join("-");
};

export const spanishDateTransformer = (date) => {
  let d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) {
    month = "0" + month;
  }

  if (day.length < 2) {
    day = "0" + day;
  }

  return [day, month, year].join("-");
};

export const formatToEurosCurrency = (data) => {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(data);
};

export const formatToDecimal = (data) => {
  return new Intl.NumberFormat("es-ES", {
    style: "decimal",
  }).format(data);
};

export const formatToTwoDecimalPlaces = (data) => {
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(data);
};

export const formatToPercent = (data) => {
  return `${formatToTwoDecimalPlaces(data)} %`;
};

export const isTodayInRange = (from, to) => {
  dayjs.extend(isBetween);
  const now = new dayjs();
  return now.isBetween(from, to, "day", "[]");
};

export const groupDataLibraryFilters = (filters) => {
  const result = [];
  const groupMap = new Map();

  filters.forEach((item) => {
    const key = `${item.dimension.code}_${item.operation.id}`;

    if (!groupMap.has(key)) {
      groupMap.set(key, {
        dimension: item.dimension,
        operation: item.operation,
        values: [],
      });
    }

    groupMap.get(key).values.push(item.value);
    if (item.endValue) {
      groupMap.get(key).values.push(item.endValue);
    }
  });

  groupMap.forEach((group) => {
    result.push({
      dimension: group.dimension,
      operation: group.operation,
      value: group.values,
    });
  });

  return result;
};
